import { nodesGroupMapper } from "@features/builder/helpers/nodesGroupMapper"
import { GraphLink } from "@features/builder/UpdateMetadata/GraphLinks/types"
import { linkEncode, linkParse } from "@components/NodeLink/linkHelpers"
import { AppNode } from "@features/builder/graph/types"

/**
 * Pure function — applies user-selected version changes from GraphLinks form to all matching nodes.
 * Only processes links where the user picked a new version (selectedVersion is set).
 * Returns the updated nodes array; returns the original array unchanged if nothing needed updating.
 */
export function applyGraphLinkUpdates(links: GraphLink[], nodes: AppNode[]): AppNode[] {
  // nodesMapper deep-copies node objects via structuredClone, so mutations on allMap values never touch the original nodes or React Flow's store
  const { allMap } = nodesGroupMapper(nodes)
  let changed = false

  for (const link of links) {
    if (!link.selectedVersion) continue

    for (const nodeId of link.nodeIds) {
      const node = allMap.get(nodeId)
      if (!node || !("metaNode" in node.data)) continue

      const parsed = linkParse(node.data.metaNode.Link)
      if (!parsed) continue

      node.data.metaNode.Link = linkEncode(
        parsed.org,
        parsed.div,
        parsed.prod,
        parsed.family,
        link.selectedVersion,
        parsed.node,
      )
      changed = true
    }
  }

  return changed ? [...allMap.values()] : nodes
}
